/** Decode JWT payload without verification (client-side RBAC hints only). */
export function decodeUserFromToken(token) {
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

/** Platform admin or superadmin (matches backend adminOnly middleware). */
export function isPlatformAdmin(user) {
  if (!user) return false;
  return (
    user.isAdmin === true ||
    user.role === 'admin' ||
    user.role === 'superadmin'
  );
}

export function isDmsAdmin(user) {
  if (!user) return false;
  return isPlatformAdmin(user) || user.dmsRole === 'admin';
}

/** Manual / technical doc editors — platform admin or superadmin only. */
export function canAccessManualEditors(user) {
  return isPlatformAdmin(user);
}

/** Structured document editor — all authenticated DMS users. */
export function canAccessDocumentEditor(user) {
  return !!user;
}

export function canAccessCustomerPortal(user) {
  if (!user) return false;
  return !isDmsAdmin(user) || user.dmsRole === 'viewer';
}